import React, { useState } from 'react';

import AiMagicIcon from '@assets/images/ai-model/ai-magic.svg';
import DownloadIcon from '@assets/icons/download.svg';

import CommonImage from '@/components/CommonImage';
const AiModelCard = ({ onOpenSidebar, imageUrl, hasEditPermission, onDownload }) => {
	const [isActive, setIsActive] = useState(false);

	return (
		<div className="one-forth">
			<div
				className={`ai-model-image cursor-pointer ${isActive ? 'active' : ''}`}
				onClick={() => setIsActive(!isActive)}
			>
				<div className="img">{imageUrl && <CommonImage src={imageUrl} isStatic={false} />}</div>
				<div className="ai-tag-and-edit d-flex align-items-center justify-content-center">
					<CommonImage
						className="cursor-pointer mr-2"
						src={DownloadIcon}
						width={20}
						height={20}
						onClick={onDownload}
						isStatic={false}
					/>
					{hasEditPermission && (
						<CommonImage
							className="cursor-pointer"
							src="/icons/upload-dark.svg"
							onClick={onOpenSidebar}
							width={20}
							height={20}
						/>
					)}
					<CommonImage className="ml-2" src={AiMagicIcon} isStatic={false} />
				</div>
			</div>
		</div>
	);
};
export default AiModelCard;
